exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".fixed-schedule .schedule-title{font-size:20px;font-weight:700}.fixed-schedule .schedule-title h4{font-size:1.2rem;font-weight:700}.fixed-schedule .content-title{font-size:16px}.fixed-schedule .content-title .schedule-content{line-height:1.3;padding:10px 20px 0;text-align:left}.fixed-schedule .team-content{padding-top:10px;color:#4c4c4c}.fixed-schedule a:hover{text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/CustomizeTerm/steps/ScheduleAppointment.scss
// module id = 8171
// module chunks = 13